module.exports = "/images/613ccf5c7a515c1a6b40c5ab5145abd9.jpg";